/* Glowvinta — scripts propios (sin librerías) */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Aparición al hacer scroll ---------- */
  var observer = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.gv-reveal:not(.gv-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('gv-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('gv-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Parallax suave del hero ---------- */
  function initParallax() {
    var imgs = document.querySelectorAll('[data-gv-parallax]');
    if (!imgs.length || reduceMotion) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var intensidad = parseFloat(img.getAttribute('data-gv-parallax')) || 0;
        var rect = img.parentElement.getBoundingClientRect();
        var progreso = (rect.top + rect.height / 2 - window.innerHeight / 2) / window.innerHeight;
        img.style.transform = 'translate3d(0,' + (progreso * intensidad * -1).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Galería del producto ---------- */
  function initGaleria(root) {
    (root || document).querySelectorAll('[data-gv-galeria]').forEach(function (galeria) {
      var principal = galeria.querySelector('[data-gv-principal]');
      var video = galeria.querySelector('[data-gv-video]');
      if (!principal) return;
      galeria.querySelectorAll('[data-gv-mini]').forEach(function (mini) {
        mini.addEventListener('click', function () {
          galeria.querySelectorAll('[data-gv-mini]').forEach(function (m) { m.classList.remove('is-activa'); });
          mini.classList.add('is-activa');
          if (mini.getAttribute('data-tipo') === 'video') {
            if (!video) return;
            if (video.getAttribute('src') !== mini.getAttribute('data-video')) {
              video.src = mini.getAttribute('data-video');
              video.poster = mini.getAttribute('data-poster') || '';
              video.setAttribute('aria-label', mini.getAttribute('data-alt') || '');
            }
            video.hidden = false;
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
            return;
          }
          if (video) { video.pause(); video.hidden = true; }
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = mini.getAttribute('data-src');
            principal.srcset = mini.getAttribute('data-srcset') || '';
            principal.alt = mini.getAttribute('data-alt') || '';
            principal.style.opacity = '1';
          }, 200);
        });
      });
    });
  }

  /* ---------- Formato de precio ---------- */
  function formatoPrecio(centimos, plantilla) {
    var valor = (centimos / 100).toFixed(2);
    var partes = valor.split('.');
    var conComa = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + partes[1];
    var conPunto = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + partes[1];
    return (plantilla || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conComa)
      .replace(/\{\{\s*amount\s*\}\}/, conPunto)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, partes[0])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, partes[0]);
  }

  /* ---------- Variantes, cantidad y añadir al carrito ---------- */
  function initProducto(root) {
    (root || document).querySelectorAll('[data-gv-producto]').forEach(function (bloque) {
      if (bloque.dataset.gvListo) return;
      bloque.dataset.gvListo = '1';
      var form = bloque.querySelector('form[action*="/cart/add"]');
      var inputId = form ? form.querySelector('input[name="id"]') : null;
      var boton = bloque.querySelector('[data-gv-anadir]');
      var textoBoton = boton ? boton.querySelector('span') : null;
      var error = bloque.querySelector('[data-gv-error]');
      var datos = bloque.querySelector('[data-gv-variantes]');
      var variantes = datos ? JSON.parse(datos.textContent) : [];
      var plantilla = bloque.getAttribute('data-gv-moneda');

      /* Cantidad */
      var cantidad = bloque.querySelector('[data-gv-cantidad]');

      /* Packs: cada opción fija la cantidad */
      bloque.querySelectorAll('[data-gv-pack]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (cantidad) cantidad.value = radio.value;
          bloque.querySelectorAll('.gv-pack').forEach(function (l) {
            l.classList.toggle('is-activo', l.contains(radio));
          });
        });
      });
      bloque.querySelectorAll('[data-gv-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(cantidad.value, 10) || 1;
          v = b.getAttribute('data-gv-cant') === '+' ? v + 1 : Math.max(1, v - 1);
          cantidad.value = v;
        });
      });

      /* Variantes */
      function actualizarVariante() {
        var elegidas = [];
        bloque.querySelectorAll('[data-gv-opcion]').forEach(function (grupo) {
          var marcado = grupo.querySelector('input:checked');
          elegidas.push(marcado ? marcado.value : null);
        });
        var variante = variantes.find(function (v) {
          return v.options.every(function (o, i) { return o === elegidas[i]; });
        });
        if (!variante) {
          if (boton) boton.disabled = true;
          if (textoBoton) textoBoton.textContent = boton.getAttribute('data-txt-nodisp');
          return;
        }
        if (inputId) inputId.value = variante.id;
        bloque.querySelectorAll('[data-gv-precio-actual]').forEach(function (el) { el.textContent = formatoPrecio(variante.price, plantilla); });
        bloque.querySelectorAll('[data-gv-precio-antes]').forEach(function (el) {
          if (variante.compare_at_price && variante.compare_at_price > variante.price) {
            el.textContent = formatoPrecio(variante.compare_at_price, plantilla);
            el.hidden = false;
          } else { el.hidden = true; }
        });
        bloque.querySelectorAll('[data-gv-descuento]').forEach(function (el) {
          if (variante.compare_at_price && variante.compare_at_price > variante.price) {
            var pct = Math.round((variante.compare_at_price - variante.price) * 100 / variante.compare_at_price);
            el.textContent = '-' + pct + '%';
            el.hidden = false;
          } else { el.hidden = true; }
        });
        if (boton) {
          boton.disabled = !variante.available;
          if (textoBoton) textoBoton.textContent = variante.available ? boton.getAttribute('data-txt-anadir') : boton.getAttribute('data-txt-agotado');
        }
        if (variante.featured_media) {
          var mini = bloque.querySelector('[data-gv-mini][data-media-id="' + variante.featured_media.id + '"]');
          if (mini) mini.click();
        }
      }
      bloque.querySelectorAll('[data-gv-opcion] input').forEach(function (i) { i.addEventListener('change', actualizarVariante); });

      /* Añadir al carrito con el cajón de Dawn */
      if (form) {
        form.addEventListener('submit', function (e) {
          var drawer = document.querySelector('cart-drawer');
          if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return; // envío normal → /cart
          e.preventDefault();
          if (error) error.textContent = '';
          boton.disabled = true;
          boton.classList.add('is-cargando');
          var fd = new FormData(form);
          if (cantidad) fd.set('quantity', cantidad.value);
          fd.append('sections', 'cart-drawer,cart-icon-bubble');
          fd.append('sections_url', window.location.pathname);
          fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
            body: fd
          })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res.status) {
                if (error) error.textContent = res.description || res.message || 'No se ha podido añadir.';
                return;
              }
              drawer.classList.remove('is-empty');
              drawer.renderContents(res);
            })
            .catch(function () { form.submit(); })
            .finally(function () {
              boton.disabled = false;
              boton.classList.remove('is-cargando');
            });
        });
      }

      /* Barra fija en móvil */
      var barra = document.querySelector('[data-gv-barra]');
      if (barra && boton && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var pasado = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            barra.classList.toggle('is-visible', pasado);
          });
        }).observe(boton);
        var botonBarra = barra.querySelector('button');
        if (botonBarra) botonBarra.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(boton); else boton.click();
        });
      }
    });
  }

  function initTodo(root) {
    initReveal(root);
    initGaleria(root);
    initProducto(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    try {
      initTodo(document);
      initParallax();
    } catch (e) {
      /* Si algo falla, que nunca quede contenido oculto */
      document.documentElement.classList.remove('gv-js');
    }
  });

  /* Editor de Shopify: re-inicializar al cambiar ajustes */
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
